import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledSettingCard = styled.div`
  background-color: ${({ theme }) => theme.colors.background.light};
  border-radius: 0.6rem;
  padding: 4.6rem;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  width: 100%;
  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    padding: 3.2rem 1.8rem;
  }
`;

export const StyledCardHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  & {
    height: 2.4rem;
    width: 2.4rem;
    color: ${({ theme }) => theme.colors.info.main};
  }
`;
export const StyledHeaderTitle = styled.h2`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0rem;
`;
